document.addEventListener("DOMContentLoaded", function(){
	let handleIntersection = (entries, observer) => {
		if (!entries[0].isIntersecting) return;

		observer.unobserve(productComplementarySection);

		let url = productComplementarySection.dataset.url;

		fetch(url)
			.then(response => response.text())
			.then(text => {
				let html = document.createElement('div');
				html.innerHTML = text;
				let recommendations = html.querySelector('.product-complementary');

				if (recommendations && recommendations.innerHTML.trim().length) {
					productComplementarySection.innerHTML = recommendations.innerHTML;
				}
			})
			.catch(e => {
				console.error(e);
			});
	};

	let productComplementarySection = document.querySelector('.product-complementary');
	let observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

	observer.observe(productComplementarySection);
});